<template>
  <modal
    name="collective-equipment-modal"
    :height="isMobile ? '100%' : 'auto'"
    :width="isMobile ? '100%' : '50%'"
    :scrollable="true"
    @before-open="loadInitialSelection"
    @closed="resetForm()"
    :pivotY="0.3"
  >
    <!-- Header -->
    <div
      class="pt-3 pb-2 pr-4 pl-4 border-b border-gray-200 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 w-full flex items-center justify-between"
    >
      <h4 class="text-lg font-semibold">
        <i class="fas fa-tools mr-2"></i>
        Gerekli Ekipmanları Seç
      </h4>
      <button @click="$modal.hide('collective-equipment-modal')">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6 bg-white dark:bg-gray-900 text-black dark:text-gray-200">
      <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Toplu planlama için gerekli ekipman türlerini seçin. Seçilen ekipmanlara sahip araçlar öncelikli olarak önerilecektir.
      </p>

      <!-- Ekipman Türü Seçimi -->
      <div class="mb-4">
        <label class="block text-sm font-medium mb-2">
          <i class="fas fa-layer-group mr-2"></i>
          Ekipman Türleri
        </label>

        <div class="grid grid-cols-2 gap-3">
          <div
            v-for="category in availableCategories"
            :key="category.key"
            @click.stop="toggleCategory(category.key)"
            :class="[
              'p-4 border-2 rounded-lg cursor-pointer transition-all',
              selectedCategories.includes(category.key)
                ? 'border-blue-600 bg-blue-50 dark:bg-blue-900 dark:bg-opacity-30'
                : 'border-gray-300 dark:border-gray-600 hover:border-blue-400'
            ]"
          >
            <div class="flex items-center justify-between mb-2">
              <span class="font-medium">{{ category.label }}</span>
              <i
                v-if="selectedCategories.includes(category.key)"
                class="fas fa-check-circle text-blue-600"
              ></i>
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400">
              {{ category.description }}
            </p>
          </div>
        </div>
      </div>

      <!-- Seçili Türler Özeti -->
      <div v-if="selectedCategories.length > 0" class="mb-4 p-4 bg-blue-50 dark:bg-blue-900 dark:bg-opacity-20 rounded-lg">
        <p class="text-sm font-medium mb-2">Seçili Ekipman Türleri:</p>
        <div class="flex flex-wrap gap-2">
          <span
            v-for="cat in selectedCategories"
            :key="cat"
            class="px-3 py-1 bg-blue-600 text-white rounded-full text-xs font-medium flex items-center gap-2"
          >
            {{ getCategoryLabel(cat) }}
            <i @click.stop="toggleCategory(cat)" class="fas fa-times cursor-pointer hover:text-red-300"></i>
          </span>
        </div>
      </div>

      <!-- Actions -->
      <div class="mt-6 flex justify-end space-x-3">
        <button
          @click="clearSelection"
          class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800"
        >
          Temizle
        </button>
        <button
          @click="applySelection"
          class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          <i class="fas fa-check mr-2"></i>
          Uygula
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'CollectiveEquipmentModal',
  props: {
    initialSelectedCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedCategories: [],
      availableCategories: [
        {
          key: 'POMPA&HORTUM&DUSURUCU',
          label: 'Pompa & Hortum & Düşürücü',
          description: 'Pompa, hortum ve düşürücü ekipmanları'
        },
        {
          key: 'GUVENLIK',
          label: 'Güvenlik Ekipmanı',
          description: 'Güvenlik ekipmanları'
        },
        {
          key: 'YEDEK_PARCA',
          label: 'Yedek Parça',
          description: 'Yedek parçalar'
        },
        {
          key: 'DIGER',
          label: 'Diğer',
          description: 'Diğer ekipmanlar'
        }
      ]
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  methods: {
    loadInitialSelection() {
      // Modal açıldığında mevcut seçimleri yükle
      this.selectedCategories = [...this.initialSelectedCategories];
    },

    toggleCategory(category) {
      const index = this.selectedCategories.indexOf(category);
      if (index > -1) {
        this.selectedCategories.splice(index, 1);
      } else {
        this.selectedCategories.push(category);
      }
    },

    getCategoryLabel(category) {
      const labels = {
        'POMPA&HORTUM&DUSURUCU': 'Pompa & Hortum & Düşürücü',
        'GUVENLIK': 'Güvenlik Ekipmanı',
        'YEDEK_PARCA': 'Yedek Parça',
        'DIGER': 'Diğer'
      };
      return labels[category] || category;
    },

    clearSelection() {
      this.selectedCategories = [];
      // Boş seçimi parent'a bildir ve modal'ı kapat
      this.$emit('equipment-selected', []);
      this.$modal.hide('collective-equipment-modal');
    },

    applySelection() {
      this.$emit('equipment-selected', this.selectedCategories);
      this.$modal.hide('collective-equipment-modal');
    },

    resetForm() {
      this.selectedCategories = [];
    }
  }
};
</script>

<style>
/* Modalın ve overlay'in z-index'ini artır - add-plan-modal'ın üstünde görünmesi için */
.v--modal-overlay[data-modal="collective-equipment-modal"] {
  z-index: 999998 !important;
}

.v--modal[data-modal="collective-equipment-modal"] {
  z-index: 999999 !important;
}
</style>
